import {
  computed,
  inject,
  provide,
  toValue,
  type ComputedRef,
  type InjectionKey,
  type MaybeRefOrGetter,
} from 'vue';

/**
 * Texts that shared components render themselves (modal actions, close
 * buttons). The host app provides its translations once through `App`;
 * anything not provided falls back to English.
 */
export type UiLabels = {
  close: string;
  cancel: string;
  confirm: string;
  delete: string;
  save: string;
  apply: string;
  filters: string;
  resetFilters: string;
  breadcrumbs: string;
};

export const defaultLabels: UiLabels = {
  close: 'Close',
  cancel: 'Cancel',
  confirm: 'Confirm',
  delete: 'Delete',
  save: 'Save',
  apply: 'Apply',
  filters: 'Filters',
  resetFilters: 'Reset all filters',
  breadcrumbs: 'Breadcrumbs',
};

export const LABELS_INJECTION_KEY: InjectionKey<
  MaybeRefOrGetter<Partial<UiLabels>>
> = Symbol('exfluential-labels');

export const provideLabels = (
  labels: MaybeRefOrGetter<Partial<UiLabels>>,
): void => {
  provide(LABELS_INJECTION_KEY, labels);
};

export const useLabels = (): ComputedRef<UiLabels> => {
  const provided = inject(LABELS_INJECTION_KEY, {});
  return computed(() => ({ ...defaultLabels, ...toValue(provided) }));
};
